// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3w8nS","modalForm":"UpgradeEpcsModal_modalForm__1TcUQ","modalFooter":"UpgradeEpcsModal_modalFooter__33Piv"};